var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5402 11.79L9.88023 6.14001C9.78726 6.04628 9.67666 5.97188 9.5548 5.92111C9.43294 5.87035 9.30224 5.84421 9.17023 5.84421C9.03821 5.84421 8.90751 5.87035 8.78565 5.92111C8.66379 5.97188 8.55319 6.04628 8.46023 6.14001C8.27398 6.32737 8.16943 6.58082 8.16943 6.84501C8.16943 7.10919 8.27398 7.36264 8.46023 7.55001L13.4102 12.55L8.46023 17.5C8.27398 17.6874 8.16943 17.9408 8.16943 18.205C8.16943 18.4692 8.27398 18.7226 8.46023 18.91C8.55284 19.0045 8.66329 19.0797 8.78516 19.1312C8.90704 19.1827 9.03792 19.2095 9.17023 19.21C9.30253 19.2095 9.43342 19.1827 9.55529 19.1312C9.67717 19.0797 9.78761 19.0045 9.88023 18.91L15.5402 13.26C15.6417 13.1664 15.7227 13.0527 15.7781 12.9262C15.8336 12.7997 15.8622 12.6631 15.8622 12.525C15.8622 12.3869 15.8336 12.2503 15.7781 12.1238C15.7227 11.9973 15.6417 11.8836 15.5402 11.79Z",
    fill: "#1F1F1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight2);
export default __webpack_public_path__ + "static/media/arrow-right-2.88b655f636bc0fd6ee520a6c1bbb6b04.svg";
export { ForwardRef as ReactComponent };